module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M1.78 10.98h28.44a1.673 1.673 0 0 1 0 3.344H1.78a1.671 1.671 0 1 1 0-3.344z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/marketing-highlight.js
// module id = 1256
// module chunks = 14